import * as Registration from "./Registration";
import * as Sidebar from "./Sidebar";

// eslint-disable-next-line
export default { Sidebar, Registration };
